import { __awaiter, __generator } from "tslib";
import { getUserStorageItem, } from '@office-start/user-storage-service';
import { getUserItem as getLocalStorageUserItem } from '@office-start/web-storage-utility';
import { filterPriorityData } from '../helpers/filterPriorityData';
import { LegacyStorageKey, LocalLegacyStorageKey } from '../models/Constants';
/**
 * Legacy data should only have been saved for PWA Consumer users.
 */
export function getLegacyFirstRunDataFromStorage(options, identity, skipUserStorage) {
    return __awaiter(this, void 0, void 0, function () {
        var legacyCacheData, legacyNetworkData, legacyFirstRunData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    legacyCacheData = getLocalStorageUserItem(identity.puid, LocalLegacyStorageKey) || null;
                    if (skipUserStorage) {
                        return [2 /*return*/, legacyCacheData];
                    }
                    return [4 /*yield*/, getUserStorageItem(LegacyStorageKey, options)];
                case 1:
                    legacyNetworkData = (_a.sent()) || null;
                    legacyFirstRunData = filterPriorityData(legacyNetworkData, legacyCacheData);
                    return [2 /*return*/, legacyFirstRunData];
            }
        });
    });
}
//# sourceMappingURL=getLegacyFirstRunDataFromStorage.js.map